/**
 * Create a function that will return a singleton instance of a passed class.
 * The function is useful for when we need to make sure that we return one
 * single instance of a class after the first call.
 */
export function createSingletonGetter<T>(constructor: new () => T): () => T {
  let instance: T | undefined
  return () => {
    if (!instance) {
      instance = new constructor()
    }
    return instance
  }
}
